import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { LegalPage, P, UL } from "@/components/marketing/LegalPage";

export const Route = createFileRoute("/legal/kyc-vietnam")({
  head: () => ({
    meta: [
      { title: "KYC, Xác Minh Đơn Vị Tổ Chức (Việt Nam) — banana.cards" },
      { name: "description", content: "Quy định nhận biết khách hàng, xác minh doanh nghiệp, chủ sở hữu hưởng lợi và tài khoản ngân hàng của Banana Cards Việt Nam." },
      { property: "og:title", content: "KYC, Xác Minh Đơn Vị Tổ Chức (Việt Nam) — banana.cards" },
      { property: "og:description", content: "Quy định KYC, xác minh doanh nghiệp và chủ sở hữu hưởng lợi dành cho Đơn Vị Tổ Chức tại Việt Nam." },
    ],
    links: alternateLinkList("/legal/kyc-vietnam", "en"),
  }),
  component: KycVietnamPage,
});

export function KycVietnamPage() {
  return (
    <LegalPage
      eyebrow="Pháp lý · Xác minh"
      title="Nhận Biết Khách Hàng &"
      italic="Xác Minh Đơn Vị Tổ Chức."
      updated="Tháng 01 năm 2026"
      intro="Đơn Vị Tổ Chức đồng ý rằng Banana Cards Việt Nam có quyền thực hiện các biện pháp nhận biết khách hàng, xác minh doanh nghiệp, xác minh người đại diện, xác minh chủ sở hữu hưởng lợi, xác minh tài khoản ngân hàng, kiểm tra thuế, kiểm tra rủi ro thanh toán, phòng chống gian lận, phòng chống rửa tiền, chống tài trợ khủng bố và các biện pháp tuân thủ liên quan trước khi phê duyệt tài khoản, xuất bản sự kiện, kích hoạt chức năng bán vé, kích hoạt chức năng thu phí Đơn Vị Triển Lãm, xử lý hoàn tiền hoặc thực hiện giải ngân."
      related={[
        { label: "KYC — Global", to: "/legal/kyc-global" },
        { label: "AML — Việt Nam", to: "/legal/aml-vietnam" },
        { label: "Điều Khoản Bán Vé (Việt Nam)", to: "/legal/ticketing-vietnam" },
      ]}
      sections={[
        {
          id: "yeu-cau-xac-minh",
          title: "1. Yêu Cầu Xác Minh",
          body: (
            <>
              <P>Banana Cards có thể yêu cầu Đơn Vị Tổ Chức hoàn tất quy trình xác minh trước khi được sử dụng một phần hoặc toàn bộ các chức năng bán vé, quản lý Đơn Vị Triển Lãm, thu thanh toán, giải ngân, phối hợp hóa đơn, check-in, báo cáo hoặc các chức năng nền tảng khác. Việc xác minh có thể được yêu cầu:</P>
              <UL items={[
                "trước khi tài khoản Đơn Vị Tổ Chức được phê duyệt",
                "trước khi sự kiện được xuất bản",
                "trước khi vé có thu phí được mở bán",
                "trước khi chức năng thu phí Đơn Vị Triển Lãm được kích hoạt",
                "trước khi khoản giải ngân được thực hiện",
                "khi doanh thu vé, khoản thanh toán từ Đơn Vị Triển Lãm, khoản hoàn tiền, chargeback hoặc yêu cầu giải ngân vượt ngưỡng rủi ro nội bộ",
                "khi Đơn Vị Tổ Chức thay đổi tài khoản ngân hàng, thông tin pháp lý, thông tin thuế, người đại diện, chủ sở hữu hưởng lợi, thông tin sự kiện hoặc chỉ dẫn giải ngân",
                "khi Banana Cards, ngân hàng, cổng thanh toán, tổ chức thẻ, ví điện tử, nhà cung cấp dịch vụ thanh toán hoặc cơ quan có thẩm quyền yêu cầu kiểm tra bổ sung",
              ]} />
              <P>Banana Cards có thể áp dụng mức độ xác minh khác nhau tùy theo loại hình Đơn Vị Tổ Chức, quốc gia hoặc địa phương liên quan, loại sự kiện, quy mô giao dịch, số tiền giải ngân, lịch sử hoàn tiền, tỷ lệ chargeback, phương thức thanh toán, loại Đơn Vị Triển Lãm, nguồn tiền và mức độ rủi ro tổng thể.</P>
            </>
          ),
        },
        {
          id: "thong-tin",
          title: "2. Thông Tin và Tài Liệu Có Thể Được Yêu Cầu",
          body: (
            <>
              <P>Banana Cards có thể yêu cầu Đơn Vị Tổ Chức cung cấp thông tin và tài liệu bao gồm nhưng không giới hạn ở:</P>
              <UL items={[
                "tên pháp lý và tên thương mại",
                "giấy chứng nhận đăng ký doanh nghiệp, giấy phép hoạt động, quyết định thành lập hoặc tài liệu tương đương",
                "mã số thuế",
                "địa chỉ đăng ký và địa chỉ hoạt động",
                "thông tin người đại diện theo pháp luật và người được ủy quyền quản lý tài khoản",
                "giấy ủy quyền, quyết định bổ nhiệm, xác nhận chức vụ hoặc tài liệu chứng minh quyền đại diện",
                "giấy tờ định danh của người đại diện, người được ủy quyền, quản trị viên tài khoản hoặc người phê duyệt giải ngân khi cần thiết",
                "thông tin cổ đông, thành viên góp vốn, chủ sở hữu thực tế, chủ sở hữu hưởng lợi hoặc bên kiểm soát thực tế",
                "cơ cấu sở hữu và kiểm soát của Đơn Vị Tổ Chức",
                "thông tin tài khoản ngân hàng và bằng chứng tài khoản thuộc về Đơn Vị Tổ Chức",
                "thông tin hóa đơn, thông tin thuế và thông tin liên hệ kế toán",
                "tên, mô tả, địa điểm, ngày tổ chức, quy mô, sức chứa và mục đích thương mại của sự kiện",
                "loại vé, giá vé, gói Đơn Vị Triển Lãm, gói tài trợ, gói gian hàng, chính sách hoàn tiền và doanh thu dự kiến",
                "hợp đồng địa điểm, hợp đồng tài trợ, hợp đồng Đơn Vị Triển Lãm, báo giá, hóa đơn, chứng từ thanh toán hoặc tài liệu hỗ trợ khác",
                "thông tin nguồn tiền, cơ sở thương mại của giao dịch hoặc giải trình về dòng tiền khi sự kiện hoặc giao dịch có rủi ro cao",
                "bất kỳ thông tin nào khác được yêu cầu hợp lý cho mục đích xác minh, thanh toán, giải ngân, thuế, hóa đơn, phòng chống gian lận, phòng chống rửa tiền, chống tài trợ khủng bố hoặc tuân thủ pháp luật",
              ]} />
              <P>Đơn Vị Tổ Chức phải cung cấp thông tin đầy đủ, chính xác, cập nhật, hợp pháp và không gây hiểu nhầm.</P>
            </>
          ),
        },
        {
          id: "chu-so-huu-huong-loi",
          title: "3. Chủ Sở Hữu Hưởng Lợi và Kiểm Soát Thực Tế",
          body: (
            <>
              <P>Khi Đơn Vị Tổ Chức là công ty, hộ kinh doanh, tổ chức, hiệp hội, câu lạc bộ, quỹ, tổ chức phi lợi nhuận, đơn vị giáo dục, đơn vị y tế, đơn vị nhà nước, đơn vị liên kết hoặc bất kỳ cấu trúc pháp lý nào khác, Banana Cards có thể yêu cầu thông tin về cá nhân hoặc tổ chức cuối cùng sở hữu, kiểm soát, quản lý hoặc hưởng lợi từ Đơn Vị Tổ Chức. Thông tin này có thể bao gồm:</P>
              <UL items={[
                "cổ đông, thành viên góp vốn hoặc chủ sở hữu",
                "chủ sở hữu hưởng lợi",
                "người đại diện theo pháp luật",
                "giám đốc, người quản lý, thành viên hội đồng quản trị, người kiểm soát hoặc người điều hành",
                "người được ủy quyền ký kết, tạo sự kiện, nhận thanh toán, yêu cầu giải ngân hoặc thay đổi tài khoản ngân hàng",
                "cá nhân hoặc tổ chức nhận lợi ích kinh tế từ doanh thu vé, doanh thu Đơn Vị Triển Lãm, phí gian hàng, phí tài trợ hoặc các khoản thu khác",
              ]} />
              <P>Đơn Vị Tổ Chức phải thông báo kịp thời cho Banana Cards khi có thay đổi trọng yếu về chủ sở hữu, chủ sở hữu hưởng lợi, quyền kiểm soát, người đại diện, người được ủy quyền, quản trị viên tài khoản, tài khoản ngân hàng, thông tin thuế hoặc thông tin giải ngân.</P>
            </>
          ),
        },
        {
          id: "quyen-dai-dien",
          title: "4. Quyền Đại Diện và Thẩm Quyền Hành Động",
          body: (
            <>
              <P>Đơn Vị Tổ Chức cam đoan rằng bất kỳ cá nhân nào tạo tài khoản, xuất bản sự kiện, cấu hình vé, thu phí Đơn Vị Triển Lãm, yêu cầu giải ngân, thay đổi tài khoản ngân hàng, tải lên tài liệu, xác nhận thông tin hoặc chấp thuận các Điều Khoản này đều có đầy đủ thẩm quyền hành động thay mặt Đơn Vị Tổ Chức.</P>
              <P>Banana Cards có thể yêu cầu bằng chứng về thẩm quyền, bao gồm giấy ủy quyền, quyết định bổ nhiệm, hợp đồng lao động, xác nhận chức vụ, phê duyệt nội bộ, nghị quyết công ty hoặc tài liệu tương đương. Banana Cards có thể tạm dừng quyền truy cập tài khoản, việc xuất bản sự kiện, chức năng thu thanh toán hoặc việc giải ngân nếu không thể xác minh người hành động thay mặt Đơn Vị Tổ Chức có thẩm quyền hợp lệ.</P>
            </>
          ),
        },
        {
          id: "danh-sach-rui-ro",
          title: "5. Kiểm Tra Danh Sách Rủi Ro, Cảnh Báo và Đối Tượng Bị Hạn Chế",
          body: (
            <>
              <P>Banana Cards có thể kiểm tra Đơn Vị Tổ Chức, người đại diện, người được ủy quyền, chủ sở hữu hưởng lợi, tài khoản nhận tiền, Khách Hàng, Đơn Vị Triển Lãm, nhà tài trợ, đối tác sự kiện và các bên liên quan theo danh sách cảnh báo, danh sách bị hạn chế, danh sách bị phong tỏa, danh sách cấm giao dịch, cơ sở dữ liệu người có ảnh hưởng chính trị, thông tin bất lợi trên truyền thông, cơ sở dữ liệu gian lận, dữ liệu rủi ro thanh toán hoặc các nguồn tuân thủ khác.</P>
              <P>Banana Cards có thể từ chối, tạm dừng, trì hoãn, hoàn, đảo, hủy hoặc không thực hiện việc phê duyệt tài khoản, xuất bản sự kiện, thu thanh toán, hoàn tiền hoặc giải ngân nếu có cơ sở hợp lý cho rằng việc tiếp tục giao dịch có thể tạo ra rủi ro pháp lý, AML/CFT, gian lận, thanh toán, thuế, hóa đơn hoặc tuân thủ.</P>
            </>
          ),
        },
        {
          id: "xac-minh-nang-cao",
          title: "6. Xác Minh Nâng Cao",
          body: (
            <>
              <P>Banana Cards có thể yêu cầu xác minh nâng cao khi Đơn Vị Tổ Chức, sự kiện, mô hình giao dịch, quốc gia hoặc địa phương liên quan, phương thức thanh toán, loại Khách Hàng, loại Đơn Vị Triển Lãm, cơ cấu sở hữu, tài khoản giải ngân hoặc các yếu tố khác có rủi ro cao. Xác minh nâng cao có thể bao gồm:</P>
              <UL items={[
                "bổ sung tài liệu định danh hoặc tài liệu doanh nghiệp",
                "xác minh nguồn tiền hoặc cơ sở thương mại của giao dịch",
                "rà soát hợp đồng địa điểm, hợp đồng Đơn Vị Triển Lãm, hợp đồng tài trợ hoặc tài liệu sự kiện",
                "rà soát giá vé, giá gian hàng, giá tài trợ, sức chứa địa điểm, doanh thu dự kiến và tính hợp lý thương mại",
                "xác minh thêm chủ sở hữu hưởng lợi và quyền kiểm soát thực tế",
                "xác minh tài khoản ngân hàng và điểm đến giải ngân",
                "rà soát hành vi hoàn tiền, chargeback và lịch sử giao dịch",
                "kiểm tra thêm về danh sách cảnh báo, người có ảnh hưởng chính trị, thông tin bất lợi hoặc gian lận",
                "yêu cầu phê duyệt thủ công trước khi mở bán vé, thu phí Đơn Vị Triển Lãm hoặc giải ngân",
              ]} />
              <P>Banana Cards có thể từ chối cung cấp dịch vụ hoặc trì hoãn giải ngân nếu quy trình xác minh nâng cao không được hoàn tất theo đánh giá hợp lý của Banana Cards.</P>
            </>
          ),
        },
        {
          id: "giam-sat-cap-nhat",
          title: "7. Giám Sát Liên Tục và Cập Nhật Thông Tin",
          body: (
            <>
              <P>Quy trình KYC và xác minh Đơn Vị Tổ Chức không chỉ áp dụng tại thời điểm mở tài khoản. Banana Cards có thể rà soát, cập nhật và yêu cầu xác minh lại thông tin trong suốt quá trình Đơn Vị Tổ Chức sử dụng nền tảng. Đơn Vị Tổ Chức phải cung cấp thông tin cập nhật kịp thời nếu:</P>
              <UL items={[
                "tên pháp lý thay đổi",
                "tên thương mại thay đổi",
                "địa chỉ đăng ký hoặc địa chỉ hoạt động thay đổi",
                "chủ sở hữu hoặc chủ sở hữu hưởng lợi thay đổi",
                "người đại diện theo pháp luật, người được ủy quyền hoặc quản trị viên tài khoản thay đổi",
                "thông tin mã số thuế hoặc hóa đơn thay đổi",
                "tài khoản ngân hàng hoặc thông tin giải ngân thay đổi",
                "mô hình hoạt động sự kiện thay đổi đáng kể",
                "Banana Cards yêu cầu tài liệu hoặc thông tin cập nhật",
              ]} />
              <P>Banana Cards có thể tạm dừng hoặc hạn chế dịch vụ nếu thông tin trở nên lỗi thời, không đầy đủ, không nhất quán, không thể xác minh, gây hiểu nhầm hoặc có rủi ro cao.</P>
            </>
          ),
        },
        {
          id: "tai-khoan-ngan-hang",
          title: "8. Xác Minh Tài Khoản Ngân Hàng và Giải Ngân",
          body: (
            <>
              <P>Banana Cards có thể yêu cầu Đơn Vị Tổ Chức chứng minh rằng tài khoản ngân hàng nhận tiền đứng tên Đơn Vị Tổ Chức hoặc được ủy quyền hợp lệ và được Banana Cards chấp thuận. Banana Cards có thể từ chối yêu cầu giải ngân đến:</P>
              <UL items={[
                "tài khoản cá nhân khi Đơn Vị Tổ Chức là công ty hoặc tổ chức",
                "tài khoản của bên thứ ba",
                "tài khoản không khớp với tên pháp lý hoặc thông tin đã xác minh của Đơn Vị Tổ Chức",
                "tài khoản không thể xác minh",
                "tài khoản có liên quan đến gian lận, tranh chấp, chargeback, giao dịch đáng ngờ hoặc hoạt động rủi ro cao",
                "tài khoản được thay đổi ngay trước thời điểm giải ngân mà không có lý do hợp lý hoặc tài liệu hỗ trợ đầy đủ",
              ]} />
              <P>Banana Cards có thể yêu cầu xác minh bổ sung trước khi chấp nhận tài khoản ngân hàng mới hoặc xử lý giải ngân sau khi thay đổi tài khoản ngân hàng.</P>
            </>
          ),
        },
        {
          id: "khong-hoan-tat",
          title: "9. Không Hoàn Tất Xác Minh",
          body: (
            <>
              <P>Nếu Đơn Vị Tổ Chức không hoàn tất các yêu cầu xác minh KYC, xác minh doanh nghiệp, xác minh chủ sở hữu hưởng lợi, xác minh tài khoản ngân hàng, xác minh thuế, kiểm tra danh sách rủi ro hoặc yêu cầu tuân thủ khác, Banana Cards có thể:</P>
              <UL items={[
                "từ chối phê duyệt tài khoản Đơn Vị Tổ Chức",
                "từ chối xuất bản hoặc tiếp tục xuất bản sự kiện",
                "vô hiệu hóa chức năng bán vé có thu phí",
                "vô hiệu hóa chức năng thu phí Đơn Vị Triển Lãm",
                "vô hiệu hóa yêu cầu giải ngân",
                "trì hoãn, tạm giữ, tạm dừng hoặc từ chối giải ngân",
                "tạm dừng hoặc hạn chế quyền truy cập vào các chức năng nền tảng",
                "hủy, hoàn, đảo hoặc từ chối giao dịch khi được yêu cầu bởi pháp luật, ngân hàng, cổng thanh toán hoặc quy trình kiểm soát rủi ro",
                "chấm dứt quyền truy cập của Đơn Vị Tổ Chức vào Banana Cards",
              ]} />
              <P>Banana Cards không chịu trách nhiệm đối với bất kỳ thiệt hại, chậm trễ, khiếu nại, chi phí hoặc tổn thất nào phát sinh do Đơn Vị Tổ Chức không hoàn tất xác minh hoặc không cung cấp thông tin cần thiết.</P>
            </>
          ),
        },
        {
          id: "tinh-chinh-xac",
          title: "10. Tính Chính Xác và Hành Vi Cung Cấp Thông Tin Sai",
          body: (
            <>
              <P>Đơn Vị Tổ Chức không được cung cấp thông tin hoặc tài liệu sai, gây hiểu nhầm, không đầy đủ, giả mạo, bị chỉnh sửa trái phép, hết hiệu lực hoặc không được ủy quyền. Việc cung cấp thông tin sai hoặc gây hiểu nhầm được xem là vi phạm nghiêm trọng các Điều Khoản này và có thể dẫn đến:</P>
              <UL items={[
                "từ chối tài khoản",
                "tạm dừng sự kiện",
                "trì hoãn hoặc từ chối giải ngân",
                "chấm dứt dịch vụ",
                "tạm giữ khoản tiền trong phạm vi pháp luật hoặc quy định thanh toán cho phép",
                "cung cấp thông tin cho ngân hàng, cổng thanh toán, tổ chức thẻ, ví điện tử, cơ quan thuế, cơ quan nhà nước, cơ quan điều tra hoặc cơ quan có thẩm quyền khi pháp luật yêu cầu hoặc cho phép",
                "thu hồi các khoản tổn thất, chi phí, hoàn tiền, chargeback, phí phạt, thiệt hại hoặc khoản phải trả phát sinh do việc cung cấp thông tin sai lệch",
              ]} />
            </>
          ),
        },
        {
          id: "ben-thu-ba",
          title: "11. Bên Thứ Ba Hỗ Trợ Xác Minh",
          body: (
            <>
              <P>Banana Cards có thể sử dụng nhà cung cấp dịch vụ xác minh danh tính, xác minh tài liệu, xác minh doanh nghiệp, cổng thanh toán, ngân hàng, dịch vụ phòng chống gian lận, công cụ kiểm tra danh sách rủi ro, nhà cung cấp dịch vụ kế toán, nhà cung cấp dịch vụ hóa đơn điện tử hoặc đối tác tuân thủ để thực hiện KYC, xác minh doanh nghiệp, xác minh tài khoản ngân hàng, kiểm tra gian lận, kiểm tra thanh toán, kiểm tra thuế và các chức năng tuân thủ liên quan.</P>
              <P>Đơn Vị Tổ Chức đồng ý rằng Banana Cards có thể chia sẻ thông tin và tài liệu cần thiết với các bên này cho mục đích xác minh, tuân thủ, thanh toán, giải ngân, quản lý rủi ro, kế toán, hóa đơn và pháp lý, phù hợp với chính sách bảo mật của Banana Cards và quy định pháp luật về bảo vệ dữ liệu cá nhân.</P>
            </>
          ),
        },
        {
          id: "xu-ly-luu-giu",
          title: "12. Xử Lý và Lưu Giữ Dữ Liệu Xác Minh",
          body: (
            <>
              <P>Banana Cards có thể thu thập, xử lý, xác minh, lưu trữ, chia sẻ và lưu giữ thông tin KYC, thông tin doanh nghiệp, thông tin chủ sở hữu hưởng lợi, thông tin thuế, thông tin tài khoản ngân hàng, thông tin sự kiện, thông tin giao dịch và thông tin tuân thủ nhằm mục đích:</P>
              <UL items={[
                "xác minh Đơn Vị Tổ Chức",
                "xác minh người đại diện và người được ủy quyền",
                "kích hoạt chức năng bán vé và thu thanh toán",
                "thực hiện giải ngân",
                "phòng chống gian lận, rửa tiền, tài trợ khủng bố và tội phạm tài chính",
                "tuân thủ nghĩa vụ pháp lý, thuế, kế toán, thanh toán, kiểm toán và lưu trữ hồ sơ",
                "giải quyết tranh chấp, hoàn tiền, chargeback, khiếu nại và yêu cầu của cơ quan có thẩm quyền",
                "thực thi các Điều Khoản này",
              ]} />
              <P>Việc xử lý dữ liệu cá nhân trong quá trình xác minh sẽ được thực hiện theo chính sách bảo mật của Banana Cards và quy định pháp luật Việt Nam về bảo vệ dữ liệu cá nhân. Banana Cards có thể lưu giữ hồ sơ xác minh và hồ sơ tuân thủ trong thời hạn cần thiết để đáp ứng yêu cầu pháp luật, kế toán, thuế, thanh toán, kiểm toán, giải quyết tranh chấp, chargeback, khiếu nại, thời hiệu pháp lý hoặc mục đích kinh doanh hợp pháp.</P>
            </>
          ),
        },
        {
          id: "khong-tiet-lo",
          title: "13. Không Bắt Buộc Tiết Lộ Lý Do Kiểm Soát Rủi Ro Chi Tiết",
          body: (
            <>
              <P>Trong phạm vi pháp luật cho phép, Banana Cards không bắt buộc phải tiết lộ chi tiết lý do, chỉ báo rủi ro, logic sàng lọc, quy tắc nội bộ, điểm rủi ro của bên thứ ba hoặc kết quả kiểm tra tuân thủ cụ thể liên quan đến quyết định KYC, xác minh doanh nghiệp, kiểm tra gian lận, kiểm tra thanh toán, trì hoãn giải ngân hoặc từ chối dịch vụ.</P>
              <P>Banana Cards có thể cung cấp thông tin chung khi phù hợp, nhưng có thể từ chối tiết lộ chi tiết nếu việc tiết lộ có thể ảnh hưởng đến an ninh hệ thống, kiểm soát rủi ro, tuân thủ pháp luật, phòng chống gian lận, phòng chống rửa tiền, yêu cầu của ngân hàng/cổng thanh toán hoặc quy trình xác minh/điều tra đang diễn ra.</P>
            </>
          ),
        },
        {
          id: "nghia-vu-tiep-dien",
          title: "14. Nghĩa Vụ Tiếp Diễn",
          body: (
            <>
              <P>Nghĩa vụ KYC, xác minh doanh nghiệp, xác minh chủ sở hữu hưởng lợi, xác minh tài khoản ngân hàng và cập nhật thông tin của Đơn Vị Tổ Chức tiếp tục có hiệu lực trong suốt thời gian Đơn Vị Tổ Chức sử dụng Banana Cards, có sự kiện đang hoạt động, có khoản giải ngân đang chờ xử lý, có khoản dự phòng, có yêu cầu hoàn tiền hoặc chargeback chưa giải quyết, hoặc còn nghĩa vụ tiếp diễn theo các Điều Khoản này.</P>
              <P>Các nghĩa vụ trong điều khoản này tiếp tục có hiệu lực sau khi tài khoản bị đóng, sự kiện kết thúc, khoản thanh toán đã được giải ngân, dịch vụ bị tạm dừng hoặc chấm dứt.</P>
            </>
          ),
        },
      ]}
    />
  );
}